import { useState } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const ContactFormSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState("idle"); // idle, submitting, success, error
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("submitting");
    setErrorMessage("");

    try {
      const response = await fetch("http://localhost:5000/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", phone: "", message: "" });
      } else {
        setStatus("error");
        setErrorMessage(data.error || "Failed to send message.");
      }
    } catch (error) {
      setStatus("error");
      setErrorMessage("Network error. Please try again later.");
    }
  };

  return (
    <section className="py-12 md:py-24 bg-slate-50">
      <div className="container-custom">

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">

          {/* Form */}

          <div className="bg-white rounded-3xl shadow-lg p-6 sm:p-8">

            <h2 className="text-2xl sm:text-3xl font-bold text-[#082B57]">
              Send Us A Message
            </h2>

            {status === "success" && (
              <div className="mt-6 p-4 bg-green-50 text-green-700 rounded-xl border border-green-200">
                Thank you! Your message has been sent successfully. We will get back to you shortly.
              </div>
            )}

            {status === "error" && (
              <div className="mt-6 p-4 bg-red-50 text-red-700 rounded-xl border border-red-200">
                {errorMessage}
              </div>
            )}

            <form onSubmit={handleSubmit} className="mt-8 space-y-5">

              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your Name"
                className="w-full border border-gray-200 rounded-xl px-5 py-4 outline-none focus:border-[#F59E0B] transition-colors"
              />

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Email Address"
                className="w-full border border-gray-200 rounded-xl px-5 py-4 outline-none focus:border-[#F59E0B] transition-colors"
              />

              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone Number"
                className="w-full border border-gray-200 rounded-xl px-5 py-4 outline-none focus:border-[#F59E0B] transition-colors"
              />

              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                placeholder="Message"
                className="w-full border border-gray-200 rounded-xl px-5 py-4 outline-none focus:border-[#F59E0B] transition-colors"
              />

              <button
                type="submit"
                disabled={status === "submitting"}
                className="w-full bg-[#F59E0B] hover:bg-orange-600 transition-colors text-white py-4 rounded-xl font-semibold disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {status === "submitting" ? "Sending..." : "Submit Inquiry"}
              </button>

            </form>

          </div>

          {/* Company Details */}

          <div>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#082B57]">
              Let's Build Something Great Together
            </h2>

            <p className="text-gray-600 mt-6 leading-8">
              Whether you're planning a new construction project,
              property investment or development opportunity,
              our team is ready to help.
            </p>

            <div className="space-y-6 mt-10">

              <div className="flex gap-4">
                <FaPhoneAlt className="text-[#F59E0B] mt-1" />
                <span>+91 99266 66609, +91 83195 69994</span>
              </div>

              <div className="flex gap-4">
                <FaEnvelope className="text-[#F59E0B] mt-1" />
                <span className="break-all">contact@azconstruction.com</span>
              </div>

              <div className="flex gap-4">
                <FaMapMarkerAlt className="text-[#F59E0B] mt-1" />
                <span>
                  2, Gandhi Gram Colony, Near Khajrana Thana, Dargah Main Road, Khajrana Indore
                </span>
              </div>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default ContactFormSection;